import { render, staticRenderFns } from "./twilio-send-email-output.vue?vue&type=template&id=2d278e1f&scoped=true"
import script from "./twilio-send-email-output.vue?vue&type=script&lang=js"
export * from "./twilio-send-email-output.vue?vue&type=script&lang=js"
import style0 from "./twilio-send-email-output.vue?vue&type=style&index=0&id=2d278e1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d278e1f",
  null
  
)

export default component.exports